
import Button from '../../../components/base/Button';
import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-gray-900 via-black to-gray-900">
      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 1px 1px, rgba(255,255,255,0.15) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Gradient Orbs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl" />
      
      {/* Content */}
      <div className="relative z-20 max-w-6xl mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm mb-8">
            <div className="w-2 h-2 bg-green-400 rounded-full mr-3 animate-pulse" />
            <span className="text-sm font-medium text-gray-300">150+ Verified AI Agencies Available</span>
          </div>
          
          <h1 className="text-6xl md:text-8xl font-light text-white mb-8 leading-[0.9] tracking-tight">
            The future of
            <br />
            <span className="font-semibold bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent">
              AI business
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-400 mb-12 max-w-2xl mx-auto font-light leading-relaxed">
            Discover, acquire, or partner with established AI agencies and service companies shaping tomorrow's economy.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-20">
            <Button 
              variant="primary" 
              size="lg" 
              className="min-w-52 h-14 text-base font-medium"
              onClick={() => navigate('/exchange')}
            >
              Explore Marketplace
              <i className="ri-arrow-right-line ml-2"></i>
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="min-w-52 h-14 text-base font-medium"
              onClick={() => navigate('/submit')}
            >
              List Your Agency
            </Button>
          </div>
          
          {/* Refined Stats */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pt-16 border-t border-white/10">
            <div className="text-center group">
              <div className="text-4xl md:text-5xl font-light text-white mb-3 group-hover:text-blue-400 transition-colors duration-300">$50M+</div>
              <div className="text-gray-500 font-medium tracking-wide uppercase text-sm">Total Asset Value</div>
            </div>
            <div className="text-center group">
              <div className="text-4xl md:text-5xl font-light text-white mb-3 group-hover:text-cyan-400 transition-colors duration-300">150+</div>
              <div className="text-gray-500 font-medium tracking-wide uppercase text-sm">Verified Agencies</div>
            </div>
            <div className="text-center group">
              <div className="text-4xl md:text-5xl font-light text-white mb-3 group-hover:text-blue-400 transition-colors duration-300">95%</div>
              <div className="text-gray-500 font-medium tracking-wide uppercase text-sm">Success Rate</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
